export const copyArray = array => {
  return JSON.parse(JSON.stringify(array));
};
